import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Alert as MuiAlert, Typography } from "@mui/material";
import { identifiersData, namesData, statusTypesData } from "data";
import React from "react";
import { useSelector } from "react-redux";
import { theme } from "theme";

const Alert = React.forwardRef((props, ref) => {
    const message = useSelector((state) => state.alertReducer.message);

    const severity = props?.severity || statusTypesData.success; // eslint-disable-line

    const alertIcon = {
        error: <ErrorIcon />,
        info: <ReportProblemIcon />,
        success: <CheckCircleIcon />,
    };

    const {
        alert: alertId,
        button: buttonId,
        message: messageId,
    } = identifiersData.ids;

    return (
        <MuiAlert
            {...props}
            elevation={6}
            icon={alertIcon[severity]}
            id={alertId}
            ref={ref}
            variant="filled"
            slotProps={{
                closeButton: { id: `${alertId}_${namesData.buttons.close}_${buttonId}` },
            }}
            style={{
                background: theme.palette.snackbar.background[severity], // eslint-disable-line
                color: theme.palette.snackbar.color[severity], // eslint-disable-line
                minWidth: "300px",
            }}
        >
            <Typography id={`${alertId}_${messageId}`}>{message}</Typography>
        </MuiAlert>
    );
});

export default Alert;
